@if (!isLoading) {
    <router-outlet />
} @else {
  Getting everything ready...
}
